/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  ConsoleResponseCode,
  ConsoleResponseMessage,
  CONSOLE_RESPONSE_CODE_ERROR,
  CONSOLE_RESPONSE_CODE_FAIL,
  CONSOLE_RESPONSE_CODE_FORBIDDEN,
  CONSOLE_RESPONSE_CODE_NOT_FOUND,
  CONSOLE_RESPONSE_CODE_NO_CONTENT,
  CONSOLE_RESPONSE_CODE_SUCCESS,
  CONSOLE_RESPONSE_CODE_UNAUTHORIZED,
  CONSOLE_RESPONSE_MESSAGE_ERROR,
  CONSOLE_RESPONSE_MESSAGE_FAIL,
  CONSOLE_RESPONSE_MESSAGE_FORBIDDEN,
  CONSOLE_RESPONSE_MESSAGE_NOT_FOUND,
  CONSOLE_RESPONSE_MESSAGE_NO_CONTENT,
  CONSOLE_RESPONSE_MESSAGE_SUCCESS,
  CONSOLE_RESPONSE_MESSAGE_UNAUTHORIZED,
} from './ConsoleResponse.entity.constant';

/**
 * All of the possible `CONSOLE_RESPONSE_CODE_*`'s.
 * @export
 */
export const CONSOLE_RESPONSE_CODES: ReadonlyArray<ConsoleResponseCode> = [
  CONSOLE_RESPONSE_CODE_ERROR,
  CONSOLE_RESPONSE_CODE_FAIL,
  CONSOLE_RESPONSE_CODE_FORBIDDEN,
  CONSOLE_RESPONSE_CODE_NO_CONTENT,
  CONSOLE_RESPONSE_CODE_NOT_FOUND,
  CONSOLE_RESPONSE_CODE_SUCCESS,
  CONSOLE_RESPONSE_CODE_UNAUTHORIZED,
];

/**
 * All of the possible `CONSOLE_RESPONSE_MESSAGES_*`'s.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGES: ReadonlyArray<ConsoleResponseMessage> = [
  CONSOLE_RESPONSE_MESSAGE_ERROR,
  CONSOLE_RESPONSE_MESSAGE_FAIL,
  CONSOLE_RESPONSE_MESSAGE_FORBIDDEN,
  CONSOLE_RESPONSE_MESSAGE_NO_CONTENT,
  CONSOLE_RESPONSE_MESSAGE_NOT_FOUND,
  CONSOLE_RESPONSE_MESSAGE_SUCCESS,
  CONSOLE_RESPONSE_MESSAGE_UNAUTHORIZED,
];
